import { getAspectRatio } from "./getAspectRatio";
import { getBreakpoint } from "./getBreakpoint";
export const getCarouselHeight = (screenWidth, screenHeight) => {
    const breakpoint = getBreakpoint(screenWidth);
    if (breakpoint === "desktop") {
        return Math.min(630, screenHeight * 0.6);
    }
    return Math.min(screenHeight * 0.66, screenWidth / getAspectRatio(screenWidth));
};
//# sourceMappingURL=getCarouselHeight.js.map